<template>
  <section
    class="header-container"
    v-if="!rootStore.isMobile"
    :class="{ 'files-selected': fileStoreStore.hasSelectedFiles }"
  >
    <bread-crumbs :levels="levels" @level-changed="goToFolder"></bread-crumbs>

    <button
      v-if="fileStoreStore.hasSelectedFiles"
      @click="addSelectedToFileList"
      class="pill-button"
    >
      Toevoegen aan winkelwagen
    </button>
    <search-menu
      :archive-id="archiveId"
      :folder-id="folderId"
      @search-completed="goToSearchResults"
    ></search-menu>
  </section>

  <section class="header-mobile" v-else>
    <section class="header-top">
      <search-menu
        :archive-id="archiveId"
        :folder-id="folderId"
        @search-completed="goToSearchResults"
      ></search-menu>
    </section>
    <section class="header-bottom">
      <bread-crumbs :levels="levels" @level-changed="goToFolder"></bread-crumbs>
    </section>
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import FileNavigationMixin from '@/features/filestore/FileNavigationMixin.js'
import SearchMenu from '@/features/filestore/children/SearchMenu.vue'
import BreadCrumbs from '@/features/filestore/children/BreadCrumbs.vue'
import { EventBus, Events } from '@/eventbus/EventBus'

export default {
  components: { BreadCrumbs, SearchMenu },
  props: ['archiveId', 'folderId'],
  mixins: [FileNavigationMixin],
  computed: {
    ...mapStores(useFileStoreStore),
    levels() {
      return this.fileStoreStore.getFolderPath(this.folderId) || []
    }
  },
  methods: {
    goToFolder(folderId) {
      this.$router.push({
        name: 'fileStoreFolder',
        params: { archiveId: this.archiveId, folderId: folderId }
      })
    },
    goToSearchResults() {
      this.$router.push({ name: 'fileStoreSearchResults' })
    },
    addSelectedToFileList() {
      EventBus.emit(
        Events.ADD_FILE_STORE_FILES_TO_SELECTION,
        this.fileStoreStore.browserSelectedFileIds
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  width: 100%;
  color: var(--sub-color);
  font-weight: 600;
  display: grid;
  grid-template-columns: auto 40px;
  align-items: center;

  &.files-selected {
    grid-template-columns: auto 200px 40px;
  }

  .top-menu {
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
}

.header-mobile {
  width: 100%;
  .header-top {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 24px;
    padding-right: 8px;
  }
  .header-bottom {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 24px;
    margin-left: -8px;
    width: calc(100vw - 16px);
  }
}
</style>
